import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CompanyCtx = createContext(null);

export function CompanyProvider({ children }) {
  const [company, setCompany] = useState(null);
  useEffect(() => {
    api.get("/settings/company").then((r) => setCompany(r.data)).catch(() => {});
  }, []);
  const refresh = () => api.get("/settings/company").then((r) => setCompany(r.data));
  return <CompanyCtx.Provider value={{ company, refresh }}>{children}</CompanyCtx.Provider>;
}

export const useCompany = () => useContext(CompanyCtx);
